import type { PartSvgProps } from './types'

export default function AkGasTubeSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  width = 220,
  height = 40
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 220 40" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <rect x="18" y="12" width="184" height="16" rx="8"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      <ellipse cx="18" cy="20" rx="10" ry="10" fill={stroke} />
      <ellipse cx="202" cy="20" rx="8" ry="8" fill={stroke} />
    </svg>
  )
}
